export * from "./minWidthTablet.widths";
